import React, { useState, useEffect, useContext } from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useLazyGetGPSDetailViewDetailsQuery } from '@src/store/services/gps/onlineServices';
import { FileContext } from '@src/routes/Routes';
import { GPSDetailViewTable } from './GPSDetailViewTable';

import { LoadingScreen } from '@src/common/LoadingScreen';
import { encdata } from '@src/constants';
import CryptoJS from 'crypto-js';

interface GPSDetailViewParams {
  firstName?: string;
  lastName?: string;
  customerName?: string;
  cescustnbr?: string;
  relationship?: string;
  transId?: string;
  transSetId?: string;
  fileID?: string;
  processingDt?: string;
  empId?: string;
  subscrId?: string;
  medicareId?: string;
}

export const GPSDetailView: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [gpsDetailList, setGpsDetailList] = useState<any[]>([]);
  const [detailsViewGps] = useLazyGetGPSDetailViewDetailsQuery();
  const router = useRouter();
  const [encryData, setEncryData] = useState<GPSDetailViewParams | null>(null);
  const { fileData } = useContext(FileContext);
  const { encryptedData } = router.getRouteParams();

  useEffect(() => {
    const fetchDetails = async () => {
      if (encryptedData) {
        const decryptedData = CryptoJS.AES.decrypt(
          decodeURIComponent(encryptedData),
          encdata
        ).toString(CryptoJS.enc.Utf8);
        const linkData: GPSDetailViewParams = JSON.parse(decryptedData);
        setEncryData(linkData);

        const {
          firstName,
          lastName,
          empId,
          customerName,
          cescustnbr,
          relationship,
          transId,
          transSetId,
          fileID,
          subscrId,
          medicareId,
        } = linkData;

        const response = await detailsViewGps({
          transSetId,
          lastName,
          firstName,
          empId,
          transFileId: fileID,
          platform: 0,
          customerName,
          cescustnbr,
          relationship,
          transId,
          subscrId,
          medicareId,
        });
        setGpsDetailList(response?.data);
        setIsLoading(false);
      }
    };

    fetchDetails();
  }, [encryptedData, detailsViewGps]);

  const {
    firstName,
    lastName,
    customerName,
    cescustnbr,
    relationship,
    transId,
    transSetId,

    fileID,
    processingDt,
  } = encryData || {};

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <React.Fragment>
      <Router.MetaTags title="Detail View" />
      <Layout.Stack
        css={{
          paddingTop: '40px',
          td: {
            backgroundColor: '#deebf4',
          },
        }}
        alignLayout="center"
      >
        <Layout.Stack
          css={{
            alignItems: 'stretch',
            width: '100%',
            maxWidth: '$web.semantic.max-width',
          }}
        >
          <Grid
            css={{
              width: '100%',
              paddingBottom: '10px',
            }}
          >
            <Grid.Col span="100%">
              <Text
                css={{
                  color: '$web.semantic.color.text.content.primary',
                  h1: {
                    margin: '0',
                  },
                }}
              >
                <h1>Detail View</h1>
              </Text>
            </Grid.Col>
            <Grid.Col span="100%">
              <Text>
                <b>Customer Submission group: </b>
                {customerName}
              </Text>
              <br />
              <Text>
                <b>Processing Date: </b> {processingDt?.split(' ')[0]}
              </Text>
              <br />
              <Text>
                <b>Member name: </b>
                {lastName}, {firstName}
              </Text>
            </Grid.Col>
          </Grid>
          <GPSDetailViewTable detailViewList={gpsDetailList} />
        </Layout.Stack>
      </Layout.Stack>
    </React.Fragment>
  );
};
